import React from 'react';
import BaseComponent from '../../components/system/base';
import FireBaseContext from '../../context/fireBaseContext';
import PropTypes from 'prop-types';
import PubSub from 'pubsub-js';

const $ = window;
class WinPopup extends BaseComponent {
  static contextType = FireBaseContext;
  constructor(props, context) {
    super(props, context);
    this.state = {
      redeeNow: this.props.redeemNow,
    }
  }

  redeemNow = () => {
    let newWinnings = [];
    let hasRedeemed = false;
    let customerId = this.globs.GetVar("c");
    let lowestDaysLeft = 9999999;
    this.globs.forEach($.firebaseUser.ProductWinnings[customerId], (product) => {
      if (product.ProductId === this.props.productIdWon && product.DaysLeft < lowestDaysLeft) {
        lowestDaysLeft = product.DaysLeft;
      }
    });

    this.globs.forEach($.firebaseUser.ProductWinnings[customerId], (product) => {
      if (!hasRedeemed && product.ProductId === this.props.productIdWon && lowestDaysLeft === product.DaysLeft) {
        hasRedeemed = true;
      } else {
        newWinnings.push(product);
      }
    });
    let update = $.firebaseUser;
    // $.firebaseUser comes from window and loading previous screen
    update.ProductWinnings[customerId] = newWinnings;
    let userDoc = this.context.firebase.firestore().collection("users").doc($.user.uid);
    userDoc.set(update);
  }

  render() {
    let fromBusiness = <div className="center" style={{paddingTop: 10, }}>
            <span className="pink" style={{fontSize: 16}}>{this.translate["from"]}</span>
            <span style={{fontSize: 26, marginLeft: 20}}>{this.props.businessName}</span>
          </div>;
    let terms = this.props.terms.length > 0 && <div className="center" style={{fontSize: 12, paddingTop: 14}}>* {this.props.terms}</div>
    let RedeemNow = (props) => {
      return (
        <div className="center">
          <div style={{width: 200, height: 52, marginTop: 20, backgroundRepeat: "no-repeat", backgroundImage: "url('/images/content/winningPopup/redeem.png')"}} {...this.globs.touchAndClick(props.onClick)}>
            <div className="center" style={{fontSize: 26, color: "black", marginTop: 7}}>{this.translate["redeemNow"]}</div>
          </div>
        </div>
      )
    }
    return (
      <React.Fragment>
        {!this.state.redeeNow ? <span>
          <img style={{marginTop: 5, width: "100%"}} src="/images/content/winningPopup/congratulations.png" alt="Congratulations"/>
          <div className="pink center" style={{fontSize: 21}}>{this.translate["youWon"]}</div>
          <div className="pink center" style={{fontSize: 17, marginTop: 10}}>{this.props.productNameWon} <img style={{width: 141, marginLeft: 15}} src={"/images/content/winningPopup/" + this.props.category + ".png"} alt={"Category "+ this.props.category}/></div>
          <div style={{width: "90%", height: 333, borderRadius: 25, backgroundColor: "#342a2a", marginTop: 15, marginLeft: 15, marginRight: 15}}>
            {terms}
            {fromBusiness}
            <div style={{marginTop: 20}} className="center"><img style={{width: "75%"}} src={this.props.businessImage} alt="Business Image"/></div>
            <RedeemNow onClick={() => {
              this.setState({redeeNow: true})
            }}/>
          </div>
          {this.props.expireDays > 0 && <div className="center" style={{fontSize: 12, paddingTop: 14}}>* {this.globs.__(this.translate["mustBeRedeemedWithinDays"], {dayCount: this.props.expireDays})}</div>}
          <div {...this.globs.touchAndClick(() => {
                PubSub.publish('redeem-done', {
                  productIdWon: this.props.productIdWon
                });
              })}>
            <div className="center"><img style={{width: 100}} src="/images/content/winningPopup/save.png" alt="Save For Later"/></div>
            <div className="pink center" style={{fontSize: 16}}>{this.translate["saveForLater"]}</div>
          </div>
        </span>:
        <span>
          <div style={{width: "90%", height: 116, borderRadius: 25, backgroundColor: "white", marginLeft: 15, marginRight: 15, fontSize: 22}} className="center pink">
            <span style={{margin: 30}}>{this.translate["readyToRedeem"]}</span>
          </div>
          <span className="center">{this.translate["ifSoShowThis"]}</span>
          <div className="center">
            <img style={{marginTop: 5, width: "100%"}} src="/images/content/redeemNow/fireworks.png" alt="Fireworks"/>
          </div>
          <div style={{width: "90%", height: 200, borderRadius: 25, backgroundColor: "#342a2a", marginLeft: 15, marginRight: 15, paddingTop: 20, paddingBottom: 30, fontSize: 28}} className="pink">
            <div className="pink center" style={{fontSize: 25, marginTop: 10}}>{this.props.productNameWon} <img style={{width: 120, marginLeft: 15}} src={"/images/content/winningPopup/" + this.props.category + ".png"} alt={"Category "+ this.props.category}/></div>
            {terms}
            {fromBusiness}
            <RedeemNow onClick={() => {
              let response = window.confirm(this.translate["confirmStaffMember"]);
              if (response) {
                PubSub.publish('redeem-done', {
                  productIdWon: this.props.productIdWon
                });
                this.redeemNow();
              }
            }}/>
            <br/>
            <div className="center" style={{color: "white", fontSize: 15}} {...this.globs.touchAndClick(() => {
              PubSub.publish('redeem-done', {
                productIdWon: this.props.productIdWon
              });
            })}>{this.translate["cancel"]}</div>
          </div>
        </span>}

      </React.Fragment>
    );
  }
}

WinPopup.propTypes = {
  productNameWon : PropTypes.string,
  businessImage : PropTypes.string,
  expireDays : PropTypes.number,
  category : PropTypes.string,
  category : PropTypes.string,
  productIdWon : PropTypes.string,
  businessName : PropTypes.string,
  terms : PropTypes.string,
  redeeNow : PropTypes.bool
};

export default WinPopup


// WEBPACK FOOTER //
// ./src/content/winPrize/winPopup.js